<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="car_decode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_decode || "需求单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.car_decode }}
          </div>
        </div>
        <div class="weui-cell" slot="de_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_name || "项目名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_name }}
          </div>
        </div>
        <div class="weui-cell" slot="de_custname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_custname || "需求来源"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_custname }}
          </div>
        </div>
        <div class="weui-cell" slot="de_product_type">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_product_type || "产品类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_product_type }}
          </div>
        </div>
        <div class="weui-cell" slot="de_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_emname || "需求人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="de_dpname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_dpname || "需求部门"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_dpname }}
          </div>
        </div>
        <div class="weui-cell" slot="car_project_classify">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_project_classify || "项目分类"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.car_project_classify"
              placeholder="请选择"
            >
              <option>销售立项</option>
              <option>产品立项</option>
              <option>技术立项</option>
            </select>
          </div>
        </div>
        <div class="weui-cell" slot="car_project_level">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_project_level || "项目等级"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.car_project_level"
              placeholder="请选择"
            >
              <option>高</option>
              <option>中</option>
              <option>低</option>
            </select>
          </div>
        </div>
        <employee-field
          :label="customLabel.car_emname || '项目负责人'"
          v-model="form.main.car_emname"
          @select="onSelectEmployee"
          slot="car_emname"
        />

        <div class="weui-cell" slot="car_budget">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_budget || "项目预算金额"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_budget"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_invest_cost">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_invest_cost || "投入成本"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_invest_cost"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_research_cost">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_research_cost || "研发成本"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_research_cost"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_equipment_cost">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_equipment_cost || "设备投入成本"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_equipment_cost"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_competitor_price">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_competitor_price || "竞品价格分析"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.car_competitor_price"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_material_cost">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_material_cost || "材料成本"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_material_cost"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_labor_cost">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_labor_cost || "人工成本"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_labor_cost"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_item_cost">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_item_cost || "项目投入成本"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_item_cost"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_product_apportion_cost">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_product_apportion_cost || "产品分摊成本"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_product_apportion_cost"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_product_price">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_product_price || "预估产品售价"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_product_price"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_product_price">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_product_price || "预估产品售价"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.car_product_price"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="car_product_profit">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.car_product_profit || "预估产品毛利率(%)"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.car_product_profit"
              placeholder="请输入"
            />
          </div>
        </div>
        <currency-field
          slot="car_currency"
          :label="customLabel.car_currency || '币种'"
          v-model="form.main.car_currency"
        />
      </custom-layout>

      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.car_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    EmployeeField,
    CurrencyField,
    FileField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/plm/costAnalyseReport",
      codeField: "car_code",
      statusField: "car_statuscode",
      caller: "CostAnalyseReport",
      xtype: "plm-costanalysereport-formpanel",
      form: {
        main: {
          car_deid: null,
          car_decode: null,
          de_name: null,
          de_custid: null,
          de_custcode: null,
          de_custname: null,
          de_product_type: null,
          de_emname: null,
          de_dpname: null,
          car_project_classify: null,
          car_project_level: null,
          car_emname: null,
          car_emcode: null,
          car_emid:null,
          car_budget:null,
          car_invest_cost:null,
          car_research_cost:null,
          car_equipment_cost:null,
          car_competitor_price:null,
          car_material_cost:null,
          car_labor_cost:null,
          car_item_cost:null,
          car_product_apportion_cost:null,
          car_product_price:null,
          car_product_profit:null,
          car_currency:null,
          car_attach:null,
        },
      },
    };
  },
  methods: {
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.car_emid = selection.id;
      main.car_emcode = selection.em_code;
    },

    /**
     * 保存
     */
    save() {
      var me = this;
      me.p_save();
    },
  },
};
</script>
